import React from "react"

export default function Vote() {
   return (
      <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
         <g clipPath="url(#clip0_171_8019)">
            <path d="M7.09556 10.0699H7.29556C8.06556 10.0699 8.69556 10.6999 8.69556 11.4699V18.4699C8.69556 19.2399 8.06556 19.8699 7.29556 19.8699H7.09556C6.32556 19.8699 5.69556 19.2399 5.69556 18.4699V11.4699C5.69556 10.6999 6.32556 10.0699 7.09556 10.0699ZM12.6956 5.86987C13.4656 5.86987 14.0956 6.49987 14.0956 7.26987V18.4699C14.0956 19.2399 13.4656 19.8699 12.6956 19.8699C11.9256 19.8699 11.2956 19.2399 11.2956 18.4699V7.26987C11.2956 6.49987 11.9256 5.86987 12.6956 5.86987ZM18.2956 13.8699C19.0656 13.8699 19.6956 14.4999 19.6956 15.2699V18.4699C19.6956 19.2399 19.0656 19.8699 18.2956 19.8699C17.5256 19.8699 16.8956 19.2399 16.8956 18.4699V15.2699C16.8956 14.4999 17.5256 13.8699 18.2956 13.8699Z" fill="#B8BAC2" />
         </g>
         <defs>
            <clipPath id="clip0_171_8019">
               <rect width="24" height="24" fill="white" transform="translate(0.695557 0.869873)" />
            </clipPath>
         </defs>
      </svg>
   )
}